"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var utils_1 = require("@doshexchnage/utils");
var useClient_1 = require("../../../../../../hooks/useClient");
function useRenderCellViews() {
    var client = (0, useClient_1.useClient)().client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        var commonTextStyles = "text-sm capitalize text-default-foreground";
        var nowrapTextStyles = "text-nowrap text-sm capitalize text-default-foreground";
        return [
            { key: "transaction_id", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "date_time", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: (0, utils_1.formatDateTime)(new Date(cellValue)) }) },
            { key: "user_id", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "user_name", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "branch_location", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "transaction_type", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "value", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "xp_points_earned", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
            { key: "wallet_balance_post_transaction", content: (0, jsx_runtime_1.jsx)("div", { className: commonTextStyles, children: cellValue }) },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
